import React from 'react';
import FinancialHighlight from "../../../assets/investor/financial-highlight.png";
import CompanyProfile from "../../../assets/investor/company-profile.png";
import CompanyReport from "../../../assets/investor/company-report.png";
import CompanySustainability from "../../../assets/investor/company-sustainability.png";
import {Link} from 'react-router-dom';

function CorporateInfoCardListing () {

    const infoData = [
        {
            no: "01",  
            title: "Financial Highlight",
            description: "Unveiling the financial journey: A snapshot of our fiscal achievements and milestones.",
            link: "https://kpj.listedcompany.com/highlights.html",
            image: FinancialHighlight,
        },
        {
            no: "02",  
            title: "Board of Directors & Senior Management Team",
            description: "Meet our accomplished Board of Directors and dedicated Senior Management Team, leading us towards a brighter future.",
            link: "https://kpj.listedcompany.com/directors.html",
            image: CompanyProfile,
        },
        {
            no: "03",  
            title: "Annual Reports",
            description: "You'll find a detailed summary of our accomplishments and progress throughout the year here.",
            link: "https://kpj.listedcompany.com/ar.html",
            image: CompanyReport,
        },
        {
            no: "04",  
            title: "Investor Relations Slides",
            description: "Dive into our financial performance and future outlook for deeper insights.",
            link: "https://kpj.listedcompany.com/slides.html",
            image: CompanySustainability,
        },
      ];

    return (
        <>
        <div className="investor-home-section">
            <div className="invest-home-info-gallery">
                {infoData.map((item, index) => (
                <Link
                    to={item.link}
                    key={index}
                    //className={`panel ${activePanel === index ? "active" : ""}`}
                    //onMouseEnter={() => handlePanelClick(index)}
                    className="info-card"
                    style={{
                        backgroundImage: `url("${item.image}")`,
                    }}
                >
                    <div className={`overlay-info-card-${index}`}></div>
                    <div className="info_card_subs">
                    <div className="number_title_subs" style={{ padding:"150px 50px 50px 50px" }}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <img
                                src="./../img/icon/white-dashed.svg"
                                alt=""
                                style={{ width: "30px", marginRight: "10px" }}
                            />
                            <p style={{ fontWeight: "400",textAlign: "start", alignItems: "center", margin: "0", color:"white" }}>{`0${index + 1}`}</p>
                        </div>
                        <h3 style={{marginTop: "30px", marginBottom: "30px", color:"white" }}>
                        {item.title}
                        </h3>
                        <h6 style={{color:"white", fontWeight: "400", marginBottom:"20px" }}>{item.description}</h6>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <img
                                src="./../img/icon/white-right-arrow.svg"
                                alt=""
                                style={{ width: "5px", marginRight: "10px" }}
                            />
                            <p style={{ fontSize: "14px", fontWeight: "600", color: "white", textAlign: "start", alignItems: "center", margin: "0" }}>Learn More</p>
                        </div>
                    </div>
                    </div>
                </Link>
                ))}
            </div>

            {/* mobile view */}
            <div className="investor-home-section">
            <div className="invest-home-info-gallery-mobile">
                {infoData.map((item, index) => (
                <Link
                    to={item.link}
                    key={index}
                    //className={`panel ${activePanel === index ? "active" : ""}`}
                    //onMouseEnter={() => handlePanelClick(index)}
                    className="info-card"
                    style={{
                        backgroundImage: `url("${item.image}")`,
                    }}
                >
                    <div className="overlay-info-card"></div>
                    <div className={"info_card_subs"}>
                    <div id="number_title_subs" style={{ padding:"50px" }}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <img
                                src="./../img/icon/white-dashed.svg"
                                alt=""
                                style={{ width: "30px", marginRight: "10px" }}
                            />
                            <p style={{ fontWeight: "400", color: "white", textAlign: "start", alignItems: "center", margin: "0" }}>{`0${index + 1}`}</p>
                        </div>
                        <h3 style={{marginTop: "30px", marginBottom: "30px", color:"white" }}>
                        {item.title}
                        </h3>
                        <h6 style={{color:"white", fontWeight: "400", marginBottom:"20px" }}>{item.description}</h6>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <img
                                src="./../img/icon/white-right-arrow.svg"
                                alt=""
                                style={{ width: "5px", marginRight: "10px" }}
                            />
                            <p style={{ fontSize: "14px", fontWeight: "600", color: "white", textAlign: "start", alignItems: "center", margin: "0" }}>Learn More</p>
                        </div>
                    </div>
                    </div>
                </Link>
                ))}
            </div>
            </div>
        </div>
        </>
    )
}

export default CorporateInfoCardListing;